import Messages from "./Messages/Messages";
import Documents from "./Documents/Documents";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { useEffect } from "react";
import { fetchCustomerMessages } from "../../../redux/clientPortal/clientPortalslice";
interface messageProps {
  customerId: string;
  notify: (
    title: string,
    message: string,
    type: "success" | "error" | "warning"
  ) => void;
}
const ClientPortalData = ({ notify, customerId }: messageProps) => {
  const activeClient: any = useSelector(
    (state: RootState) => state.activeClient
  );
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (customerId) {
      dispatch(fetchCustomerMessages({ customerId }));
    }
  }, [dispatch, customerId]);

  const { customerMessages, customerDocuments } = useSelector(
    (state: RootState) => state.portal
  );
  const partnerId = activeClient.basicDetails?.associated_with;
  const idsToMatch = partnerId ? [customerId, partnerId] : [customerId];

  return (
    <div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "20px",
          padding: "10px 0",
          height: "calc(100vh - 300px)",
        }}
      >
        <Messages
          customerId={customerId}
          notify={notify}
          partnerId={partnerId}
          idsToMatch={idsToMatch}
          customerMessages={customerMessages}
        />
        <Documents
          customerId={customerId}
          notify={notify}
          partnerId={partnerId}
          idsToMatch={idsToMatch}
          customerDocuments={customerDocuments}
        />
      </div>
    </div>
  );
};

export default ClientPortalData;
